export const Atmosphere = () => (
  <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden="true">
    <div
      className="absolute inset-0"
      style={{
        background:
          "radial-gradient(1200px circle at 18% -5%, rgba(0,245,212,0.08), transparent 60%), radial-gradient(1000px circle at 88% 28%, rgba(30,58,95,0.38), transparent 65%), radial-gradient(900px circle at 50% 105%, rgba(245,158,11,0.05), transparent 60%)",
      }}
    />
    {/* static ambient orbs — no infinite motion, keeps the GPU idle while scrolling */}
    <div className="atmo-orb absolute -left-40 top-1/4 h-[520px] w-[520px] rounded-full bg-teal-500/10 blur-[140px]" />
    <div className="atmo-orb absolute right-[-10%] top-[55%] h-[460px] w-[460px] rounded-full bg-[#1E3A5F]/40 blur-[130px]" />
    <div className="atmo-orb absolute left-[38%] top-[68%] h-[380px] w-[380px] rounded-full bg-teal-400/[0.07] blur-[120px]" />
  </div>
);
